define([

], function() {

	return {};
});